document.addEventListener('DOMContentLoaded', () => {
  const langButton = document.querySelector('.c-header__prebutton');
  const langList = document.querySelector('.js-lang-item');

  if (!langButton || !langList) return;

  langButton.addEventListener('click', (e) => {
    e.stopPropagation();
    langList.classList.toggle('open');
  });

  document.addEventListener('click', (e) => {
    if (!langList.contains(e.target) && !langButton.contains(e.target)) {
      langList.classList.remove('open');
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      langList.classList.remove('open');
    }
  });
});
